class Weather {

  el = null;
  weatherData = null;
  activeCity = null;

  constructor($el) {
    this.el = $el;
    if (!this.el.length) {
      console.log("Error loading weather module");
      return;
    }
    this.weatherData = JSON.parse(this.el.find(".header-weather__data")[0].innerHTML);
    this.activeCity = this.fetchActiveCity();
    this.init();
  }

  init() {
    this.events();

    // If there is an active city, fetch the weather data
    if (this.activeCity) {
      this.updateWeather(this.activeCity);
    }
  }

  events() {
    // Open the dropdown on click
    $(this.el).each(function () {
      $(this).find(".header-weather__toggle-open").on("click", function (e) {
        e.preventDefault();
        $(".header-weather__dropdown").toggleClass("hidden");
        $(this).toggleClass("active");
      });
    });


    // Close the dropdown if the user clicks outside of it
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".weather-item, .header-weather__dropdown").length
      ) {
        $(".header-weather__dropdown").addClass("hidden");
        $(".weather-item").removeClass("active");
      }
    });

    // Close the dropdown when clicking inside the dropdown itself
    this.el.find(".header-weather__dropdown").on("click", (event) => {
      $(".header-weather__dropdown").addClass("hidden");
      $(".weather-item").removeClass("active");
    });

    // Listen for click events on the weather items
    this.el.find(".header-weather__dropdown .weather-item").on("click", (event) => {
      const city = $(event.currentTarget).find("span").data("id");
      this.updateWeather(city);
      $(".header-weather__dropdown").addClass("hidden");
      $(".weather-item").removeClass("active");
      $(event.currentTarget).addClass("active");
    });

  }

  updateWeather(city) {
    const { icon_svg, temp, city: cityName, wind_speed, wind_dir } = this.weatherData[city];

    /**
     * Fetch and update the icon for both elements
     */
    fetch(icon_svg)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch SVG');
        return response.text();
      })
      .then(svgContent => {
        this.el.each(function () {
          $(this).find(".weather-item__icon")[0].innerHTML = svgContent;
        });
      })
      .catch(error => {
        console.error('Error loading SVG:', error);
      });

    /**
     * Update the temperature, city, wind speed, and wind direction
    */
    this.el.each(function () {
      $(this).find(".weather-item__temp")[0].innerHTML = `${Math.round(temp)}°`;
      $(this).find(".weather-item__city")[0].innerHTML = cityName;
      $(this).find(".weather-item__wind-speed")[0].innerHTML = `${Math.round(wind_speed)}m/s`;
      $(this).find(".weather-item__wind-dir")[0].innerHTML = wind_dir;
    });

    /**
     * Store the active city in the session
    */
    sessionStorage.setItem('activeCity', city);
  }

  fetchActiveCity() {
    // Check if there is an active city in the session
    const activeCity = sessionStorage.getItem('activeCity');
    if (activeCity) {
      return activeCity;
    } else {
      return null;
    }
  }
}

export default Weather;
